<template>
    <md-dialog
    md-dynamic-height
    class="close-ticket"
    v-on:md-opened="initDialog"
    :md-active.sync="show">
        <md-toolbar class="md-primary">
            <h3>Закрыть заявку</h3>
        </md-toolbar>
        <md-progress-bar v-if="inProcess" md-mode="indeterminate"></md-progress-bar>
        <rating-control v-model="rating"/>
        <md-dialog-actions>
            <md-button :disabled="!allowEmpty && rating.value == 0 || inProcess" @click="closeTicket" md-theme="green" class="md-primary md-raised">
                Закрыть заявку (вопрос решён)
            </md-button>
            <md-button :disabled="inProcess" class="md-accent md-raised" @click="show = false;">
                Отмена
            </md-button>
        </md-dialog-actions>
        
    </md-dialog>
</template>
<script>
import ratingControl from './ratingControl.vue';

import axios from "axios";
import {mapGetters} from "vuex";
export default {
    components: {
        ratingControl
    },
    name: "CloseTicket",
    props: {
        isVisible: Boolean,
        ticket: Object,
        allowEmpty: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        rating: {
            value: 0,
            text: ''
        },
        inProcess: false
    }),
    computed: {
        ...mapGetters([
				"CURRENTAPTEKA",
				'USERID',
				'CURRENTUSER']),
        show: {
            get() {
                return this.isVisible;
            },
            set(val) {
                if (!val) {
                    this.$emit('hide-close-dialog');
                }
            }
        }
    },
    methods: {
        initDialog() {
            this.rating.value = 0;
            this.rating.text = '';
            this.inProcess = false;
        },
        closeTicket() {
            let finishFunc = ()=> {
                this.inProcess = false;
                this.show = false;
                this.$emit('ticket-closed');
            }
            this.inProcess = true;
            let params = {
                    ticketNumber: this.ticket.ticketId,
                    number: this.ticket.ticketNumber,
                    title: this.ticket.titleName,

                    newMessage: this.rating.text,
                    messageForMail: this.rating.text,
                    ratingValue: this.rating.value == 0 ? null : this.rating.value,

                    clientNpp: this.CURRENTAPTEKA.npp,
                    userId: this.USERID,
                    idapt: this.CURRENTAPTEKA.idapt,

                    closeTicket: true
                };
            axios.post("data/saveMessage", JSON.stringify(params), {headers: {"Content-Type": "application/json"}}).then(
                (response) => {
                    finishFunc();
                },
                (error) => {
                    this.$store.dispatch("showSnackBar", { snackText: error });
                    finishFunc();
                }
			);
        }
    }
}
</script>
<style lang="scss">
    .input-area {
        margin: 10px;
    }
    .close-ticket {
        z-index: 1000;
        .md-dialog-container {
            height: auto;
        }
    }
    .star-container {
        font-size: 0px;
        .md-icon {
            color: gold !important;
        }
    }
    .rating-container {
        display: flex;
        flex-direction: column;
    }
</style>



// WEBPACK FOOTER //
// Components/supportNew/closeTicket.vue